import { ApiErrorMap } from './api-error-map';

const baseErrorKey = 'errors.fleet.';

const fleetErrors = [
  [-1200, `${baseErrorKey}duplicateDriverId`],
  [-1903, `${baseErrorKey}duplicateDriverId`],
  [-3200, `${baseErrorKey}duplicateVehicleId`],
  [-3405, `${baseErrorKey}duplicateVehicleId`],
  [-3500, `${baseErrorKey}vehicleUpdateIdError`],
  [-3600, `${baseErrorKey}vehicleNotFound`],
  [-3901, `${baseErrorKey}deleteVehicleFailed`],
  [-3903, `${baseErrorKey}deleteVehicleFailed`],
  [-3904, `${baseErrorKey}deleteDriverFailed`],
  [-7006, `${baseErrorKey}mapSetLimitExceeded`],
  [-7011, `${baseErrorKey}vehicleMapSetLimitExceeded`],
  [-7012, `${baseErrorKey}mapSetNameExists`],
  [-7017, `${baseErrorKey}mapSetIdError`],
  [-7022, `${baseErrorKey}vehicleGroupMapSetLimitExceeded`],
  [-8012, `${baseErrorKey}duplicateSpeedCoachingProfileName`],
  [-9003, `${baseErrorKey}duplicateVehicleGroupName`],
  [-9004, `${baseErrorKey}vehicleGroupNotFound`],
  [-9005, `${baseErrorKey}vehicleGroupLimitExceeded`],
  [-9006, `${baseErrorKey}vehicleAssignmentFailed`],
  [-9007, `${baseErrorKey}tooManyGroupsCreated`],
  [-9008, `${baseErrorKey}duplicateVehicleGroupIds`],
  [-9009, `${baseErrorKey}vehicleGroupSuppliedMultipleTimes`],
  [-9103, `${baseErrorKey}duplicateDriverGroupName`],
  [-9104, `${baseErrorKey}driverGroupNotFound`],
  [-9107, `${baseErrorKey}driverGroupLimitExceeded`],
  [-9911, `${baseErrorKey}configurationProfileHasAssignments`],
  [-9912, `${baseErrorKey}maxNumberOfConfigurationProfiles`],
  [-9913, `${baseErrorKey}duplicateConfigurationProfileName`],
  [-9948, `${baseErrorKey}invalidDataIntegrationType`],
  [-9950, `${baseErrorKey}partnerCannotSync`],
  [-10048, `${baseErrorKey}allVehiclesGroupAlreadyExists`],
] as const;

export const fleetErrorMap: ApiErrorMap = new Map(fleetErrors);

/**
 * t(errors.fleet.duplicateDriverId)
 * t(errors.fleet.duplicateVehicleId)
 * t(errors.fleet.vehicleUpdateIdError)
 * t(errors.fleet.mapSetLimitExceeded)
 * t(errors.fleet.vehicleMapSetLimitExceeded)
 * t(errors.fleet.mapSetNameExists)
 * t(errors.fleet.mapSetIdError)
 * t(errors.fleet.vehicleGroupMapSetLimitExceeded)
 * t(errors.fleet.duplicateVehicleGroupName)
 * t(errors.fleet.vehicleGroupNotFound)
 * t(errors.fleet.vehicleGroupLimitExceeded)
 * t(errors.fleet.vehicleAssignmentFailed)
 * t(errors.fleet.tooManyGroupsCreated)
 * t(errors.fleet.duplicateVehicleGroupIds)
 * t(errors.fleet.vehicleGroupSuppliedMultipleTimes)
 * t(errors.fleet.driverGroupNotFound)
 * t(errors.fleet.duplicateDriverGroupName)
 * t(errors.fleet.driverGroupLimitExceeded)
 * t(errors.fleet.configurationProfileHasAssignments)
 * t(errors.fleet.maxNumberOfConfigurationProfiles)
 * t(errors.fleet.duplicateConfigurationProfileName)
 * t(errors.fleet.duplicateSpeedCoachingProfileName)
 * t(errors.fleet.partnerCannotSync)
 * t(errors.fleet.vehicleNotFound)
 * t(errors.fleet.invalidDataIntegrationType)
 * t(errors.fleet.deleteVehicleFailed)
 * t(errors.fleet.deleteDriverFailed)
 * t(errors.fleet.allVehiclesGroupAlreadyExists)
 */
